module.exports = __webpack_public_path__ + "img/pres.c695a199.svg";